import React, {CSSProperties, ReactNode} from 'react';


export interface BodyProps {
    children: ReactNode | ReactNode[],
    style?: CSSProperties,
}

const Body = ({children, style}: BodyProps) => {

    return (
        <div className="page-body" style={style}>
            {children}
        </div>
    );
};

export default Body;
